import React, { useEffect, useState } from 'react'
import SEO from '../components/SEO'

const FALLBACK_PARTNERS = [
  {
    navn: 'Kyster Marine',
    link: 'http://kyster-marine.dk/',
    logo: ['https://assets.auxodev.dk/assets/7090fdb0-7f55-4b6b-b1f9-a2c2b33a9494/logo.png'],
    beskrivelse: 'Kyster-marine.dk',
  },
  {
    navn: 'JS Yacht',
    link: 'https://jsyacht.dk/',
    logo: ['https://assets.auxodev.dk/assets/7090fdb0-7f55-4b6b-b1f9-a2c2b33a9494/js-yacht.jpg'],
    beskrivelse: 'jsyacht.dk',
  },
  {
    navn: 'Faaborg Yacht Service',
    link: 'http://faaborgyacht.dk/',
    logo: ['https://assets.auxodev.dk/assets/7090fdb0-7f55-4b6b-b1f9-a2c2b33a9494/faaborg-yacht-service.jpg'],
    beskrivelse: 'faaborgyacht.dk',
  },
  {
    navn: 'Faaborg Bådebyggeri og Motorværksted ApS',
    link: 'https://www.faaborg-baade.dk/',
    logo: ['https://assets.auxodev.dk/assets/7090fdb0-7f55-4b6b-b1f9-a2c2b33a9494/faaborg-b-c3-a5debyggeri-og-motorv-c3-a6rksted-aps.jpg'],
    beskrivelse: 'Professionel bådreparation, ombygning og autoriseret motorværksted.',
  },
  {
    navn: 'Esbjerg Cylinder Service',
    link: 'https://ecs-itop.dk/',
    logo: ['https://assets.auxodev.dk/assets/7090fdb0-7f55-4b6b-b1f9-a2c2b33a9494/esbjerg-cylinder-service.jpg'],
    beskrivelse: 'ecs-itop.dk',
  },
  {
    navn: 'Dansk Søredningsselskab',
    link: 'http://dsrs.dk/',
    logo: ['https://assets.auxodev.dk/assets/7090fdb0-7f55-4b6b-b1f9-a2c2b33a9494/dansk-s-c3-98redningsselskab.jpg'],
    beskrivelse: 'Sikkerhed på søen og frivillig redningstjeneste.',
  },
  {
    navn: 'Søsportens Sikkerhedsråd',
    link: 'https://www.soesport.dk/',
    logo: ['https://assets.auxodev.dk/assets/7090fdb0-7f55-4b6b-b1f9-a2c2b33a9494/s-c3-b8sportens-sikkerhedsr-c3-a5d.jpg'],
    beskrivelse: 'Rådgivning, viden og sikkerhedsudstyr til søs.',
  },
  {
    navn: 'Dansk Bådskole',
    link: 'https://danskbaadskole.dk/',
    logo: ['https://assets.auxodev.dk/assets/7090fdb0-7f55-4b6b-b1f9-a2c2b33a9494/logo_1.png'],
    beskrivelse: 'danskbaadskole.dk',
  },
  {
    navn: 'Protek Marine Service',
    link: 'http://protekmarineservice.dk/',
    logo: ['https://assets.auxodev.dk/assets/7090fdb0-7f55-4b6b-b1f9-a2c2b33a9494/proteksinglelogolow.png'],
    beskrivelse: 'Skræddersyede bådkalecher, kalecherens og hyndebetræk i høj kvalitet.',
  },
  {
    navn: 'Kalechen.dk',
    link: 'http://www.kalechen.dk/',
    logo: ['https://assets.auxodev.dk/assets/7090fdb0-7f55-4b6b-b1f9-a2c2b33a9494/kalechen.jpg'],
    beskrivelse: 'Kalechen.dk',
  },
  {
    navn: 'Atlantyk',
    link: 'http://www.atlantyk.dk/',
    logo: ['https://assets.auxodev.dk/assets/7090fdb0-7f55-4b6b-b1f9-a2c2b33a9494/atlantyk.png'],
    beskrivelse: 'Atlantyk.dk',
  },
  {
    navn: 'Danske Tursejlere',
    link: 'https://dansketursejlere.dk/',
    logo: ['https://assets.auxodev.dk/assets/7090fdb0-7f55-4b6b-b1f9-a2c2b33a9494/danske-tursejlere.png'],
    beskrivelse: 'Interesseorganisation for danske tursejlere med kontante fordele og forsikringstilbud.',
  },
  {
    navn: 'Bådtransport Lars Nielsen',
    link: null,
    logo: ['https://assets.auxodev.dk/assets/7090fdb0-7f55-4b6b-b1f9-a2c2b33a9494/baadtransport-lars-nielsen.png'],
    beskrivelse: 'Sikker og erfaren transport af motor- og sejlbåde i hele Danmark.',
  },
  {
    navn: 'Nyhavn 2 Middelfart',
    link: 'https://nyhavn2middelfart.dk/',
    logo: ['https://assets.auxodev.dk/assets/7090fdb0-7f55-4b6b-b1f9-a2c2b33a9494/nyhavn2-sort-tekst-rgb-02.png'],
    beskrivelse: 'Nyhavn2.dk',
  },
]

export default function SamarbejdspartnerePage() {
  const [partners, setPartners] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetch('https://api.dev.auxo.dk/public/v2/content/samarbejdspartnere?limit=50')
      .then((res) => res.json())
      .then((data) => {
        if (data && data.items && data.items.length > 0) {
          setPartners(data.items)
        } else {
          setPartners(FALLBACK_PARTNERS)
        }
        setLoading(false)
      })
      .catch(() => {
        setPartners(FALLBACK_PARTNERS)
        setLoading(false)
      })
  }, [])

  return (
    <div className="bg-slate-50 min-h-screen py-12">
      <SEO
        title="Samarbejdspartnere - Nordfyn Marine"
        description="Se vores stærke netværk og samarbejdspartnere inden for både og maritim service hos Nordfyn Marine."
      />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-10">
        {/* Header Hero */}
        <div className="bg-[#0B1B2B] text-white p-8 sm:p-12 rounded-2xl shadow-lg relative overflow-hidden">
          <div className="relative z-10 space-y-3">
            <span className="text-[11px] font-bold uppercase tracking-[0.25em] text-[#2BABE3]">
              Netværk & Bådeekspertise
            </span>
            <h1 className="text-3xl sm:text-4xl font-serif font-bold text-white">
              Vores samarbejdspartnere
            </h1>
            <p className="text-slate-300 text-sm max-w-2xl leading-relaxed">
              Nordfyn Marine samarbejder med branchens dygtigste fagfolk, organisationer og leverandører for at sikre vores kunder den bedste service hele vejen igennem.
            </p>
          </div>
        </div>

        {/* Partners Grid */}
        {loading ? (
          <div className="text-center py-20 bg-white rounded-2xl border border-slate-200">
            <i className="fa-solid fa-spinner animate-spin text-3xl text-[#1E7BC1]" />
            <p className="text-xs text-slate-500 mt-2 font-medium">Henter samarbejdspartnere...</p>
          </div>
        ) : partners.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {partners.map((partner, index) => {
              const logoUrl =
                Array.isArray(partner.logo) && partner.logo.length > 0
                  ? partner.logo[0]
                  : null

              return (
                <div
                  key={partner.id || partner.navn || index}
                  className="bg-white rounded-2xl p-6 border border-slate-200 shadow-sm flex flex-col justify-between space-y-6 hover:shadow-md transition-shadow"
                >
                  <div className="space-y-4">
                    {logoUrl && (
                      <div className="h-20 flex items-center justify-center p-3 bg-slate-50 rounded-xl border border-slate-100">
                        <img
                          src={logoUrl}
                          alt={partner.navn}
                          className="max-h-14 max-w-full object-contain"
                        />
                      </div>
                    )}

                    <h2 className="font-serif font-bold text-xl text-slate-900">
                      {partner.navn}
                    </h2>
                  </div>

                  {partner.link && (
                    <div className="pt-2 border-t border-slate-100">
                      <a
                        href={partner.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-2 text-xs font-bold text-[#0B1B2B] hover:text-[#1E7BC1] transition-colors"
                      >
                        <span>Besøg {partner.navn}</span>
                        <i className="fa-solid fa-arrow-up-right-from-square text-[10px]" />
                      </a>
                    </div>
                  )}
                </div>
              )
            })}
          </div>
        ) : (
          <p className="text-center text-slate-500 py-12">Ingen samarbejdspartnere fundet.</p>
        )}
      </div>
    </div>
  )
}
